import React from 'react'

export const Contact = () => {
  return (
    <div className="page">
      <h1 className="page-title">Contacto</h1>
      <form className="contact" action="mailto:nestor_licona@hotmail.com">
        <input type="text" placeholder="Nombre" />
        <input type="text" placeholder="Apellidos"/>
        <input type="text" placeholder="Email"/>
        <textarea placeholder="Motivo o consulta"/>
        <input type="submit" value="Enviar"/>
      </form>
    </div>
  )
}
